// ALERT
export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";

//ADMIN LOGIN
export const AUTH_LOGIN = "AUTH_LOGIN";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_ERROR = "AUTH_ERROR";

//ITEMS
export const ADD_ITEM = "ADD_ITEM";
export const UPDATE_ITEM = "UPDATE_ITEM";
export const GET_ITEMS = "GET_ITEMS";
export const GET_ITEM = "GET_ITEM";
export const DELETE_ITEM = "DELETE_ITEM";

//SALESMAN
export const ADD_SALESMAN = "ADD_SALESMAN";
export const UPDATE_SALESMAN = "UPDATE_SALESMAN";
export const GET_SALESMANS = "GET_SALESMANS";
export const GET_SALESMAN = "GET_SALESMAN";
export const DELETE_SALESMAN = "DELETE_SALESMAN";

//VISIT
export const GET_VISITS = "GET_VISITS";

//COMPANY
export const ADD_COMPANY = "ADD_COMPANY";
export const UPDATE_COMPANY = "UPDATE_COMPANY";
export const GET_COMPANIES = "GET_COMPANIES";
export const GET_COMPANY = "GET_COMPANY";
export const DELETE_COMPANY = "DELETE_COMPANY";
export const GET_CITIES = "GET_CITIES";
export const GET_ACTIVE_CITIES = "GET_ACTIVE_CITIES";

//AMAZON ORDERS
export const GET_AMAZON_ORDERS = "GET_AMAZON_ORDERS";

//WHATS_NEW
export const GET_GLOBAL_WHATS_NEW = "GET_GLOBAL_WHATS_NEW";
export const ADD_GLOBAL_WHATS_NEW = "ADD_GLOBAL_WHATS_NEW";
export const UPDATE_GLOBAL_WHATS_NEW = "UPDATE_GLOBAL_WHATS_NEW";
export const DELETE_GLOBAL_WHATS_NEW = "DELETE_GLOBAL_WHATS_NEW";
export const GET_DASH_GLOBAL_WHATS_NEW = "GET_DASH_GLOBAL_WHATS_NEW";

//FEEDBACk
export const GET_FEEDBACK = "GET_FEEDBACK";
export const UPDATE_FEEDBACK = "UPDATE_FEEDBACK";

//GLOBAL IMEI
export const GET_CUSTOMERS = "GET_CUSTOMERS";
export const ADD_CUST = "ADD_CUST";
export const ADD_CUSTOMERS = "ADD_CUSTOMERS";
export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER";
export const DELETE_CUSTOMERS = "DELETE_CUSTOMERS";
export const GET_DASH_CUSTOMERS = "GET_DASH_CUSTOMERS";

//PRODUCTS
export const ADD_PRODUCTS = "ADD_PRODUCTS";
export const UPDATE_PRODUCTS = "UPDATE_PRODUCTS";
export const GET_PRODUCTS = "GET_PRODUCTS";
export const GET_PRODUCT = "GET_PRODUCT";
export const DELETE_PRODUCTS = "DELETE_PRODUCTS";
export const DELETE_PRODUCTS_IMAGE = "DELETE_PRODUCTS_IMAGE";
export const GET_DASH_PRODUCTS = "GET_DASH_PRODUCTS";
export const GET_TOP_BRAND = "GET_TOP_BRAND";

//BRAND
export const ADD_BRAND = "ADD_BRAND";
export const UPDATE_BRAND = "UPDATE_BRAND";
export const GET_BRANDS = "GET_BRANDS";
export const DELETE_BRAND = "DELETE_BRAND";

//MODEL
export const ADD_MODEL = "ADD_MODEL";
export const UPDATE_MODEL = "UPDATE_MODEL";
export const GET_MODELS = "GET_MODELS";
export const DELETE_MODEL = "DELETE_MODEL";

//SERIES
export const ADD_SERIES = "ADD_SERIES";
export const UPDATE_SERIES = "UPDATE_SERIES";
export const GET_SERIES = "GET_SERIES";
export const DELETE_SERIES = "DELETE_SERIES";

//COUPON
export const ADD_COUPON = "ADD_COUPON";
export const UPDATE_COUPON = "UPDATE_COUPON";
export const GET_COUPONS = "GET_COUPONS";
export const DELETE_COUPON = "DELETE_COUPON";

//NOTIFY
export const ADD_NOTIFY = "ADD_NOTIFY";
export const UPDATE_NOTIFY = "UPDATE_NOTIFY";
export const GET_NOTIFY = "GET_NOTIFY";
export const DELETE_NOTIFY = "DELETE_NOTIFY";

//PRODUCT_ORDER
export const ADD_PRODUCT_ORDER = "ADD_PRODUCT_ORDER";
export const UPDATE_PRODUCT_ORDER = "UPDATE_PRODUCT_ORDER";
export const GET_PRODUCT_ORDER = "GET_PRODUCT_ORDER";
export const DELETE_PRODUCT_ORDER = "DELETE_PRODUCT_ORDER";
export const UPDATE_PRODUCT_ORDER_STATUS = "UPDATE_PRODUCT_ORDER_STATUS";

//COUNTRY
export const ADD_COUNTRY = "ADD_COUNTRY";
export const UPDATE_COUNTRY = "UPDATE_COUNTRY";
export const UPDATE_COUNTRY_STATUS = "UPDATE_COUNTRY_STATUS";
export const GET_COUNTRYS = "GET_COUNTRYS";
export const GET_ACTIVE_COUNTRYS = "GET_ACTIVE_COUNTRYS";
export const DELETE_COUNTRY = "DELETE_COUNTRY";

//STATE
export const ADD_STATE = "ADD_STATE";
export const UPDATE_STATE = "UPDATE_STATE";
export const GET_STATES = "GET_STATES";
export const GET_ACTIVE_STATES = "GET_ACTIVE_STATES";
export const DELETE_STATE = "DELETE_STATE";

//CITY
export const ADD_CITY = "ADD_CITY";
export const UPDATE_CITY = "UPDATE_CITY";
export const UPDATE_CITY_STATUS = "UPDATE_CITY_STATUS";
export const GET_CITY = "GET_CITY";
export const DELETE_CITY = "DELETE_CITY";

//PACKAGE
export const ADD_PACKAGE = "ADD_PACKAGE";
export const UPDATE_PACKAGE = "UPDATE_PACKAGE";
export const GET_PACKAGES = "GET_PACKAGES";
export const GET_WITHOUT_PERMISSION_PACKAGES =
  "GET_WITHOUT_PERMISSION_PACKAGES";
export const DELETE_PACKAGE = "DELETE_PACKAGE";
export const UPDATE_PACKAGE_STATUS = "UPDATE_PACKAGE_STATUS";

//PACKAGE_ROLE
export const ADD_PACKAGE_ROLE = "ADD_PACKAGE_ROLE";
export const UPDATE_PACKAGE_ROLE = "UPDATE_PACKAGE_ROLE";
export const UPDATE_PACKAGE_ROLE_STATUS = "UPDATE_PACKAGE_ROLE_STATUS";
export const GET_PACKAGE_ROLES = "GET_PACKAGE_ROLES";
export const DELETE_PACKAGE_ROLE = "DELETE_PACKAGE_ROLE";

//PACKAGE_PERMISSION
export const ADD_PACKAGE_PERMISSION = "ADD_PACKAGE_PERMISSION";
export const UPDATE_PACKAGE_PERMISSION = "UPDATE_PACKAGE_PERMISSION";
export const UPDATE_PACKAGE_PERMISSION_STATUS =
  "UPDATE_PACKAGE_PERMISSION_STATUS";
export const GET_PACKAGE_PERMISSIONS = "GET_PACKAGE_PERMISSIONS";
export const DELETE_PACKAGE_PERMISSION = "DELETE_PACKAGE_PERMISSION";

//BUSINESS_TYPE
export const ADD_BUSINESS_TYPE = "ADD_BUSINESS_TYPE";
export const UPDATE_BUSINESS_TYPE = "UPDATE_BUSINESS_TYPE";
export const UPDATE_BUSINESS_TYPE_STATUS = "UPDATE_BUSINESS_TYPE_STATUS";
export const GET_BUSINESS_TYPES = "GET_BUSINESS_TYPES";
export const DELETE_BUSINESS_TYPE = "DELETE_BUSINESS_TYPE";

//GLOBAL_BILL_CODE
export const ADD_GLOBAL_BILL_CODE = "ADD_GLOBAL_BILL_CODE";
export const UPDATE_GLOBAL_BILL_CODE = "UPDATE_GLOBAL_BILL_CODE";
export const UPDATE_GLOBAL_BILL_CODE_STATUS = "UPDATE_GLOBAL_BILL_CODE_STATUS";
export const GET_GLOBAL_BILL_CODES = "GET_GLOBAL_BILL_CODES";
export const DELETE_GLOBAL_BILL_CODE = "DELETE_GLOBAL_BILL_CODE";

//GL_GROUP
export const ADD_GL_GROUP = "ADD_GL_GROUP";
export const UPDATE_GL_GROUP = "UPDATE_GL_GROUP";
export const GET_GL_GROUPS = "GET_GL_GROUPS";
export const DELETE_GL_GROUP = "DELETE_GL_GROUP";

//BANK
export const ADD_BANK = "ADD_BANK";
export const UPDATE_BANK = "UPDATE_BANK";
export const UPDATE_BANK_STATUS = "UPDATE_BANK_STATUS";
export const GET_BANKS = "GET_BANKS";
export const DELETE_BANK = "DELETE_BANK";

//BANNER
export const ADD_BANNER = "ADD_BANNER";
export const UPDATE_BANNER = "UPDATE_BANNER";
export const GET_BANNER = "GET_BANNER";
export const DELETE_BANNER = "DELETE_BANNER";

//FAQ
export const ADD_FAQ = "ADD_FAQ";
export const UPDATE_FAQ = "UPDATE_FAQ";
export const GET_FAQ = "GET_FAQ";
export const DELETE_FAQ = "DELETE_FAQ";

//SETTING
export const UPDATE_SETTING = "UPDATE_SETTING";
export const GET_SETTING = "GET_SETTING";

//Imei
export const GET_IMEI = "GET_IMEI";
export const UPDATE_GLOBAL_IMEI = "UPDATE_GLOBAL_IMEI";
export const UPDATE_GLOBAL_IMEI_STATUS = "UPDATE_GLOBAL_IMEI_STATUS";
export const GET_IMEI_BY_ID = "GET_IMEI_BY_ID";
export const DELETE_GLOBAL_IMEI = "DELETE_GLOBAL_IMEI";

// EWAY TRANSACTION
export const GET_ALL_EWAY_TRANSACTION = "GET_ALL_EWAY_TRANSACTION";
export const ADD_EWAY_TRANSACTION = "ADD_EWAY_TRANSACTION";
export const UPDATE_EWAY_TRANSACTION = "UPDATE_EWAY_TRANSACTION";
export const UPDATE_STATUS_EWAY_TRANSACTION = "UPDATE_STATUS_EWAY_TRANSACTION";
export const DELETE_EWAY_TRANSACTION = "DELETE_EWAY_TRANSACTION";

// SETTING
export const GET_ALL_SETTINGS = "GET_ALL_SETTINGS";
export const ADD_SETTINGS = "ADD_SETTINGS";
export const UPDATE_SETTINGS = "UPDATE_SETTINGS";
export const UPDATE_STATUS_SETTINGS = "UPDATE_STATUS_SETTINGS";
export const DELETE_SETTINGS = "DELETE_SETTINGS";

// PACKAGE TRANSACTION
export const GET_ALL_PACKAGE_TRANSACTION = "GET_ALL_PACKAGE_TRANSACTION";
export const ADD_PACKAGE_TRANSACTION = "ADD_PACKAGE_TRANSACTION";
export const UPDATE_PACKAGE_TRANSACTION = "UPDATE_PACKAGE_TRANSACTION";
export const UPDATE_PACKAGE_TRANSACTION_STATUS =
  "UPDATE_PACKAGE_TRANSACTION_STATUS";
export const DELETE_PACKAGE_TRANSACTION = "DELETE_PACKAGE_TRANSACTION";

// Wallet
export const GET_ALL_WALLET = "GET_ALL_WALLET";
export const ADD_WALLET = "ADD_WALLET";
export const UPDATE_WALLET = "UPDATE_WALLET";
export const UPDATE_STATUS_WALLET = "UPDATE_STATUS_WALLET";
export const DELETE_WALLET = "DELETE_WALLET";
export const GET_BALANCE = "GET_BALANCE";

// ITEMS
export const GET_ALL_ITEMS = "GET_ALL_ITEMS";
export const ADD_ITEMS = "ADD_ITEMS";
export const UPDATE_ITEMS = "UPDATE_ITEMS";
export const UPDATE_STATUS_ITEMS = "UPDATE_STATUS_ITEMS";
export const DELETE_ITEMS = "DELETE_ITEMS";